import {$,$$} from '../core/dom.js';
import {readJSON,writeJSON,STORAGE_KEYS} from '../core/storage.js';

const EMPTY_STATE=()=>({goal:'',want:null,ownership:null,capacity:null,smaller:'',result:null});
const VALID_RESULTS=new Set(['keep','shrink','park','drop']);

function cleanStored(value){
  if(!Array.isArray(value))return [];
  return value.filter(item=>item&&typeof item==='object'&&typeof item.id==='string'&&typeof item.goal==='string'&&VALID_RESULTS.has(item.result));
}

function calculateResult(state){
  if(state.want==='no'||state.ownership==='should')return 'drop';
  if(state.want==='maybe'||state.ownership==='mixed'||state.capacity==='later')return 'park';
  if(state.capacity==='smaller')return 'shrink';
  return 'keep';
}

const RESULT_COPY={
  keep:{title:'This goal can stay.',copy:'You want it, it feels like yours, and it fits the capacity you have now. Keep it without turning it into a test of your worth.'},
  shrink:{title:'Keep the goal. Change the size.',copy:'The goal can stay without staying this big. A smaller version is not a lesser version — it is the version your life can actually hold.'},
  park:{title:'Not now is a complete answer.',copy:'There may be something here worth returning to, but you do not need to carry it actively right now. Later is allowed.'},
  drop:{title:'You can put this down.',copy:'You are allowed to stop carrying goals that mostly belong to expectation, guilt, or somebody else’s idea of who you should be.'}
};

export function initGoalFilter({motion,navigation,sound}){
  const root=$('[data-screen="goal-filter"]');
  if(!root)return;

  const goalInput=$('#gfGoalInput');
  const smallerInput=$('#gfSmallerInput');
  const validation=$('#gfValidation');
  const charCount=$('#gfCharCount');
  const progress=$('#gfProgress');
  const smallerWrap=$('#gfSmallerWrap');
  const resultBtn=$('#gfResultBtn');
  const resultCard=$('#gfResultCard');
  const saveBtn=$('#gfSaveBtn');
  const saveFeedback=$('#gfSaveFeedback');

  let state=EMPTY_STATE();
  let currentSavedId=null;
  let items=cleanStored(readJSON(STORAGE_KEYS.GOAL_FILTER,[]));

  const stageLabels={goal:'Start',want:'1 of 3',ownership:'2 of 3',capacity:'3 of 3',result:'Result'};

  function markUnsaved(){
    currentSavedId=null;
    saveBtn.disabled=false;
    saveBtn.textContent='SAVE THIS DECISION';
    saveFeedback.textContent='';
  }

  function syncChoices(){
    $$('[data-gf-question]',root).forEach(button=>{
      const selected=state[button.dataset.gfQuestion]===button.dataset.gfValue;
      button.classList.toggle('is-selected',selected);
      button.setAttribute('aria-pressed',String(selected));
    });
    const smallerSelected=state.capacity==='smaller';
    smallerWrap.hidden=!smallerSelected;
    resultBtn.hidden=!state.capacity;
  }

  function showStage(name,{focus=true,scroll=true}={}){
    $$('[data-gf-stage]',root).forEach(panel=>{
      const active=panel.dataset.gfStage===name;
      panel.hidden=!active;
      panel.classList.toggle('is-active',active);
    });
    progress.textContent=stageLabels[name]||'';
    syncChoices();
    const panel=$(`[data-gf-stage="${name}"]`,root);
    queueMicrotask(()=>{
      if(scroll){
        const target=name==='goal'?root.querySelector('.gf-flow'):panel;
        target?.scrollIntoView({behavior:motion.isReduced()?'auto':'smooth',block:'start'});
      }
      if(!focus)return;
      if(name==='goal')goalInput.focus({preventScroll:true});
      else if(name==='result')resultCard.focus({preventScroll:true});
      else panel?.querySelector('button:not([hidden]),input:not([hidden])')?.focus({preventScroll:true});
    });
  }

  function resetFlow(){
    state=EMPTY_STATE();
    currentSavedId=null;
    goalInput.value='';
    smallerInput.value='';
    validation.textContent='';
    charCount.textContent='0';
    saveFeedback.textContent='';
    saveBtn.disabled=false;
    saveBtn.textContent='SAVE THIS DECISION';
    showStage('goal');
  }

  function renderResult(){
    state.result=calculateResult(state);
    const copy=RESULT_COPY[state.result];
    const card=resultCard;
    card.dataset.result=state.result;
    $('#gfResultWord').textContent=state.result.toUpperCase();
    $('#gfResultTitle').textContent=copy.title;
    $('#gfResultCopy').textContent=copy.copy;
    $('#gfResultGoal').textContent=state.goal;
    const showSmaller=state.result==='shrink'&&state.smaller.trim();
    $('#gfResultSmaller').hidden=!showSmaller;
    $('#gfResultSmallerText').textContent=showSmaller?state.smaller.trim():'';
    markUnsaved();
    showStage('result');
    if(!motion.isReduced()&&card.animate){
      card.animate([
        {opacity:.2,transform:'translateY(8px) scale(.985)'},
        {opacity:1,transform:'translateY(0) scale(1)'}
      ],{duration:280,easing:'cubic-bezier(.2,.78,.22,1)'});
    }
  }

  goalInput.addEventListener('input',()=>{
    charCount.textContent=String(goalInput.value.length);
    validation.textContent='';
    if(state.goal!==goalInput.value.trim())markUnsaved();
  });

  $('#gfStartBtn').addEventListener('click',()=>{
    const goal=goalInput.value.trim();
    if(!goal){
      validation.textContent='Give the goal a few words first.';
      goalInput.focus();
      return;
    }
    state=EMPTY_STATE();
    state.goal=goal;
    validation.textContent='';
    showStage('want');
  });

  $$('[data-gf-question]',root).forEach(button=>button.addEventListener('click',()=>{
    const question=button.dataset.gfQuestion;
    state[question]=button.dataset.gfValue;
    state.result=null;
    markUnsaved();
    syncChoices();
    if(question==='want')setTimeout(()=>showStage('ownership'),motion.isReduced()?0:90);
    else if(question==='ownership')setTimeout(()=>showStage('capacity'),motion.isReduced()?0:90);
    else if(question==='capacity'){
      if(state.capacity!=='smaller')state.smaller='';
      syncChoices();
      if(state.capacity==='smaller')setTimeout(()=>smallerInput.focus({preventScroll:true}),motion.isReduced()?0:80);
      else resultBtn.focus({preventScroll:true});
    }
  }));

  smallerInput.addEventListener('input',()=>{
    state.smaller=smallerInput.value.slice(0,180);
    markUnsaved();
  });

  resultBtn.addEventListener('click',()=>{
    if(!state.capacity)return;
    state.smaller=state.capacity==='smaller'?smallerInput.value.trim():'';
    renderResult();
  });

  $$('[data-gf-back]',root).forEach(button=>button.addEventListener('click',()=>{
    const target=button.dataset.gfBack;
    if(target==='goal'){
      goalInput.value=state.goal;
      charCount.textContent=String(state.goal.length);
    }
    showStage(target);
  }));

  saveBtn.addEventListener('click',()=>{
    if(!state.result||!state.goal)return;
    items=cleanStored(readJSON(STORAGE_KEYS.GOAL_FILTER,[]));
    const now=new Date().toISOString();
    const existingIndex=currentSavedId?items.findIndex(item=>item.id===currentSavedId):-1;
    const record={
      id:currentSavedId||crypto.randomUUID(),
      goal:state.goal,
      result:state.result,
      smallerVersion:state.result==='shrink'?(state.smaller||'').trim():'',
      answers:{want:state.want,ownership:state.ownership,capacity:state.capacity},
      createdAt:existingIndex>=0?items[existingIndex].createdAt:now,
      updatedAt:now
    };
    const previous=[...items];if(existingIndex>=0)items.splice(existingIndex,1);
    items.unshift(record);
    if(!writeJSON(STORAGE_KEYS.GOAL_FILTER,items)){items=previous;saveFeedback.textContent='Could not save. Your decision is still on this screen.';return}
    currentSavedId=record.id;
    sound.playSave();
    saveBtn.disabled=true;
    saveBtn.textContent='SAVED ✓';
    saveFeedback.textContent='Kept in Saved. You can come back to this decision later. ♡';
    navigation.say('Goal Filter decision saved');
  });

  $('#gfAgainBtn').addEventListener('click',resetFlow);

  navigation.onShow(name=>{
    if(name==='goal-filter'){
      syncChoices();
      if(document.querySelector('.app>main'))document.querySelector('.app>main').scrollTop=0;
    }
  });

  syncChoices();
  showStage('goal',{focus:false,scroll:false});
}
